import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { authLogout } from '@actions/auth-actions';
import { Box, CircularProgress } from '@material-ui/core';

import UnstyledHeading from '@components/shared/unstyled-heading';

import './layouts/not-authenticated/not-authenticated.scss';

const Logout = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authLogout());
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div styleName="not-authenticated-container">
      <Box display="flex" justifyContent="center" alignItems="center">
        <Box display="flex" flexDirection="column" alignItems="center">
          <UnstyledHeading rank={2} variant="h6">Signing out...</UnstyledHeading>
          <Box m={12}>
            <CircularProgress size={70} thickness={4} />
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default Logout;
